/* eslint-disable */
import React, { useState, useContext, useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, Checkbox, FormControlLabel, TextareaAutosize } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
import DropZone from '../../Components/DropZone';
import PageLayout from '../../Components/PageLayout';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";
import { ReactComponent as CityIcon } from "../../Assets/svg/CityIcon.svg";
import { ReactComponent as SettingIcon } from "../../Assets/svg/SettingIcon.svg";
import { ReactComponent as PlusIcon } from "../../Assets/svg/PlusIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as SreachIcon } from "../../Assets/svg/SreachIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as ArrowRightIconGreen } from "../../Assets/svg/greenArrow.svg";
import { ReactComponent as StarIcon } from "../../Assets/svg/StarIcon.svg";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
import { PropertyContext } from '../../context/property-context';
import data from '../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
import { NumericFormat } from 'react-number-format';
import {
    useParams
} from "react-router-dom";
import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
import { useUserStore } from '../../store/user';
import { ReactComponent as DownloadIcon } from "../../Assets/svg/DownloadIcon.svg";
import { ReactComponent as PersonList } from "../../Assets/svg/PersonList.svg";
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import moment from 'jalali-moment';

import { config } from '../../Components/persian-mobile-datepicker-config'
import { scrollingDiv } from '../../Components/ScrollRightToLeftDrag'
import Cookies from 'js-cookie'
import { checkPropertyCount } from '../../Components/PublicFunctions';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        className: 'tab-btn',
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
    props,
    ref,
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
            prefix=""
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};


function LocationMarker(props) {
    const [position, setPosition] = useState(null)
    const map = useMapEvents({
        click(e) {
            map.locate()
            setPosition(e.latlng)
            props.LatLongHandle(e.latlng)
        },
    })

    return position === null ? "" : (
        <Marker position={position}>
            <Popup>You are here</Popup>
        </Marker>
    )
}



function PropertyReg(props) {

    const [state, dispatch] = useContext(PropertyContext);

    let { type } = useParams()

    const { enqueueSnackbar } = useSnackbar();

    const navigate = useNavigate();

    const [imgUploadsCount, setImgUploadsCount] = useState([{}])
    const [tabValue, setTabValue] = React.useState(0);
    const [openZoneModal, setOpenZoneModal] = React.useState(false);
    const [openFloorModal, setOpenFloorModal] = React.useState(false);
    const [openEmkanatModal, setOpenEmkanatModal] = React.useState(false);
    const [openProperty, setOpenProperty] = React.useState(false);
    const [openCodeMelk, setOpenCodeMelk] = React.useState(false);
    const [openSanadModal, setOpenSanadModal] = React.useState(false);
    const [openJahatModal, setoOpenJahatModal] = React.useState(false);
    const [openNamaModal, setoOpenNamaModal] = React.useState(false);
    const [openKafpooshModal, setOpenKafpooshModal] = React.useState(false);
    const [openGarmayeshModal, setOpenGarmayeshModal] = React.useState(false);
    const [openKitchenModal, setOpenKitchenModal] = React.useState(false);
    const [openSarmayeshModal, setOpenSarmayeshModal] = React.useState(false);
    const [openMapModal, setOpenMapModal] = React.useState(false);
    const [showLoan, setShowLoan] = React.useState(false);
    const [floorNumModal, setFloorNumModal] = React.useState(false);
    const [nowDate, setNowDate] = React.useState("");
    const [yearDates, setYearDates] = React.useState([]);
    const [yearCreated, setYearCreated] = React.useState(false);
    const [uploadingPictures, setUploadingPictures] = React.useState(false);
    const [yearSlected, setYearSlected] = React.useState("");

    const [meterPrice, setMeterPrice] = React.useState(0);
    // const [openAlert, setOpenAlert] = React.useState(false);
    const [searchPropCode, setSearchPropCode] = React.useState("");
    const [showSalePrice, setShowSalePrice] = React.useState("");
    const [showPreSalePrice, setShowPreSalePrice] = React.useState("");
    const [showMortgagePrice, setShowMortgagePrice] = React.useState("");
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [areasItems, setAreasItems] = React.useState([]);
    const [validation, setValidation] = React.useState({});
    const [floorItem, setFloorItem] = React.useState({
        "FloorNo": "",
        "Infrastructure": "",
        "RoomsCount": "1",
        "Water": "",
        "Electricity": "",
        "Gas": "",
        "Phone": "",
        "Description": ""
    },);
    const [positionMap, setPositionMap] = useState([36.32386694335946, 59.579383705135136]);

    const floorTitle = { "-2": '-2', "-1": '-1', "0": 'همکف', "1": 'اول', "2": 'دوم', "3": 'سوم', "4": 'چهارم', "5": 'پنجم', "6": 'ششم', "7": 'هفتم', "8": 'هشتم', "9": 'نهم', "10": "دهم", "11": "یازدهم" }

    const accessToken = useUserStore((state) => state.accessToken)
    const userInfo = useUserStore((state) => state.userInfo)
    const setUserInfo = useUserStore((state) => state.setUserInfo)
    const propFacilities = useUserStore((state) => state.propFacilities)
    const locationId = useUserStore((state) => state.locationId)
    const locationName = useUserStore((state) => state.locationName)




    const [openTypeZone, setOpenTypeZone] = React.useState(false);
    const [typeZone, setTypeZone] = React.useState(1);

    const [showPicker, setShowPicker] = React.useState(false);
    const [showExpireDatePicker, setShowExpireDatePicker] = React.useState(false);
    const [isPriceChanging, setIsPriceChanging] = React.useState(0);




    // function handleSubmit(selectedDate) {
    //     const date = format(selectedDate.date, "YYYY/MM/DD");
    //     const events = selectedDate.events;
    //     console.log(date, events)
    //     setSelectedDateValue(date);
    //     setSelectedDateEvents(events);
    // }

    const handleOpenTypeZoneClose = () => {
        setOpenTypeZone(false);
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };

    const handleClickTypeZone = () => {
        setOpenTypeZone(true);
    };

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const handleChangeFloor = (event, itemName) => {
        setFloorItem({ ...floorItem, [itemName]: event.target.value })
        console.log("floorItem", floorItem)
    };

    const disRoomCount = (e) => {
        const tmp = { ...floorItem }
        if (tmp.RoomsCount) tmp.RoomsCount = ""
        setFloorItem(tmp)

    };

    const disFloorWater = (e) => {
        const tmp = { ...floorItem }
        if (tmp.Water) tmp.Water = ""
        setFloorItem(tmp)

    };

    const disFloorElec = (e) => {
        const tmp = { ...floorItem }
        if (tmp.Electricity) tmp.Electricity = ""
        setFloorItem(tmp)
    };

    const disFloorGas = (e) => {
        const tmp = { ...floorItem }
        if (tmp.Gas) tmp.Gas = ""
        setFloorItem(tmp)
    };

    const disFloorPhone = (e) => {
        const tmp = { ...floorItem }
        if (tmp.Phone) tmp.Phone = ""
        setFloorItem(tmp)
    };

    const submitFloorsHandle = () => {
        let flag = false
        for (const key in state.Floors) {
            if (state.Floors[key].FloorNo == floorItem.FloorNo) {
                flag = true
            }
        }

        if (!flag) {
            dispatch({
                type: "UPDATE_STATE",
                payload: { name: "Floors", value: floorItem, append: true }
            });
            const variant = 'success'
            enqueueSnackbar('طبقه شما با موفقیت ثبت شد.', { variant });
            setFloorItem({
                "FloorNo": "",
                "Infrastructure": "",
                "RoomsCount": "1",
                "Water": "",
                "Electricity": "",
                "Gas": "",
                "Phone": "",
                "Description": ""
            })
        }
    };

    const clearFloorsHandle = () => {
        setFloorItem({
            "FloorNo": "",
            "Infrastructure": "",
            "RoomsCount": "1",
            "Water": "",
            "Electricity": "",
            "Gas": "",
            "Phone": "",
            "Description": ""
        })
    }

    const setFloor = (floor) => {
        for (const key in state.Floors) {
            if (state.Floors[key].FloorNo == floor) {
                setFloorItem(state.Floors[key])
            }
        }
    };

    const removeFloor = (floor) => {

        let tmp = state.Floors

        tmp = tmp.filter(item => item.FloorNo != floor)

        dispatch({
            type: "CLEAR_ITEM",
            payload: { name: "Floors" }
        });

        for (const key in tmp) {
            dispatch({
                type: "UPDATE_STATE",
                payload: { name: "Floors", value: tmp[key], append: true }
            });
        }
    };

    const handleCloseYearCreatedModal = () => {
        setYearCreated(false);
    };

    const handleOpenYearCreatedModal = () => {
        setYearCreated(true);
    };

    const handleClickOpenZoneModal = () => {
        setOpenZoneModal(true);
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };

    const handleClose = () => {
        setOpenZoneModal(false);
    };

    const handleClickOpenFloorModal = () => {
        setOpenFloorModal(true);
        scrollingDiv()
    };

    const handleFloorClose = () => {
        setOpenFloorModal(false);
    };

    const handleClickOpenEmkanatModal = () => {
        setOpenEmkanatModal(true);
    };

    const handleEmkanatClose = () => {
        setOpenEmkanatModal(false);
    };

    const handleClickOpenPropertyModal = () => {
        setOpenProperty(true);
    };

    const handleProperyClose = () => {
        setOpenProperty(false);
    };
    const handleClickOpenOpenCodeMelk = () => {
        setOpenCodeMelk(true);
    };
    const handleCodeMelkClose = () => {
        setOpenCodeMelk(false);
    };

    const handleClickOpenSanadModal = () => {
        setOpenSanadModal(true);
    };
    const handleCloseSanadModal = () => {
        setOpenSanadModal(false);
    };

    const handleClickOpenJahatModal = () => {
        setoOpenJahatModal(true);
    };
    const handleCloseJahatModal = () => {
        setoOpenJahatModal(false);
    };

    const handleClickOpenNamaModal = () => {
        setoOpenNamaModal(true);
    };
    const handleCloseNamaModal = () => {
        setoOpenNamaModal(false);
    };

    const handleClickOpenKafpooshModal = () => {
        setOpenKafpooshModal(true);
    };
    const handleCloseKafpooshModal = () => {
        setOpenKafpooshModal(false);
    };

    const handleClickOpenGarmayeshModal = () => {
        setOpenGarmayeshModal(true);
    };
    const handleCloseGarmayeshModal = () => {
        setOpenGarmayeshModal(false);
    };

    const handleClickOpenKitchenhModal = () => {
        setOpenKitchenModal(true);
    };
    const handleCloseKitchenModal = () => {
        setOpenKitchenModal(false);
    };

    const handleClickOpenSarmayeshModal = () => {
        setOpenSarmayeshModal(true);
    };
    const handleCloseSarmayeshModal = () => {
        setOpenSarmayeshModal(false);
    };

    const handleClickOpenMapModal = () => {
        setOpenMapModal(true);
    };
    const handleCloseMapModal = () => {
        setOpenMapModal(false);
    };

    const handleOpenFloorNumModal = () => {
        setFloorNumModal(true);
    };
    const handleCloseFloorNumModal = () => {
        setFloorNumModal(false);
    };


    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    //Areas Pagination

    const [areaOfsset, setAreaOfsset] = React.useState(0);
    const [hasMoreOffset, setHasMoreOffset] = React.useState(true);
    const [areasLoading, setAreasLoading] = React.useState(true);
    const [areaInPlusing, setAreaInPlusing] = React.useState(true);

    const areaOnScroll = () => {
        if (document.getElementById("areas-container")) {
            const scrollTop = document.getElementById("areas-container").scrollTop
            const scrollHeight = document.getElementById("areas-container").scrollHeight
            const clientHeight = document.getElementById("areas-container").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && areaInPlusing) {
                setAreaInPlusing(false)
                setAreaOfsset(areaOfsset => areaOfsset + 40);

                // setSearchData({"name":"Offset","value":ofsset})
                console.log("areaOfsset", areaOfsset)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    }, [areasItems])

    useEffect(() => {
        console.log("offset use")

        if (hasMoreOffset && areasItems.length) {
            if (typeZone == "1")
                getAreas(false, "", "/areas/list")
            if (typeZone == "2")
                getAreas(false, "", "/webapp/divar_areas/list")
        }
    }, [areaOfsset])



    const getAreas = (resetState = false, name = "", url = "/areas/list") => {
        if (resetState) {
            setAreasItems([])
            setAreaOfsset(0);
            setHasMoreOffset(true)
        }

        setAreasLoading(true)


        const data = {
            "LocationId": locationId,
            "AgencyId": JSON.parse(Cookies.get('agency')).Id,
            "Offset": areaOfsset,
            "Limit": 40
        }

        console.log("data", data)

        if (name != "") data["Name"] = name

        try {
            http({
                // url of the api endpoint (can be changed)
                url: url,
                method: "POST",
                data: data
            }).then((res) => {
                const tempAreas = [...areasItems]
                if (res.data.result.items.length > 0) {
                    if (!resetState) {
                        res.data.result.items.map((item, index) => {
                            tempAreas.push(item)
                        })
                        setAreasItems(tempAreas)
                        console.log("resetState not")
                    }
                    else
                        setAreasItems(res.data.result.items)

                    console.log("areasItems", areasItems)


                } else {
                    console.log("End")
                    setHasMoreOffset(false)
                    if (resetState) setAreasItems([])

                }
                setTimeout(function () { setAreaInPlusing(true) }, 1000)
                setAreasLoading(false)


            });
        } catch (e) {
            console.error(e);
            setAreasLoading(false)
        }
    }
    ///////////////////////




    const RegisterDateHandle = (selectedDate) => {
        const date = format(selectedDate.date, "yyyy/MM/dd");
        const events = selectedDate.events;
        console.log(selectedDate.date, events)
        // console.log(moment.unix(+selectedDate.date).format("jYYYY/jMM/jDD"));
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "RegisterDate", value: +selectedDate.date }
        });
    }


    const ExpireDateHandle = (selectedDate) => {
        const date = format(selectedDate.date, "yyyy/MM/dd");
        const events = selectedDate.events;
        console.log("state.ExpireDate", state.ExpireDate)
        console.log(+selectedDate.date)

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "ExpireDate", value: +selectedDate.date }
        });
    }

    const PhoneHandle = (e) => {
        // console.log(e.target.value)
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Phone", value: e.target.value }
        });
    }

    const MobileHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Mobile", value: e.target.value }
        });
    }

    const PropertyTypeHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PropertyType", value: e.target.value }
        });
    }

    const AddressHandle = (e) => {
        console.log("PhysicalAddress", e.target.value)
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PhysicalAddress", value: e.target.value }
        });
    }


    const InfrastructureHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Infrastructure", value: e.target.value }
        });
    }

    const SpaceHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Space", value: e.target.value }
        });
    }

    const RoomsCountHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "RoomsCount", value: e.target.value }
        });
    }

    const disRoomsCountHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "RoomsCount", value: "" }
        });
    }

    // const StoreyNoHandle = (e) => {

    //     dispatch({
    //         type: "UPDATE_STATE",
    //         payload: { name: "RoomsCount", value: "" }
    //     });
    // }

    const StoreyNoHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "StoreyNo", value: e.target.value }
        });
    }

    const disStoreyNoHandle = (e) => {
        console.log("StoreyNo", state.StoreyNo)
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "StoreyNo", value: "" }
        });
    }

    const StoreyCountHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "StoreyCount", value: e.target.value }
        });
    }

    const disStoreyCountHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "StoreyCount", value: "" }
        });
    }

    const UnitsCountHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "UnitsCount", value: e.target.value }
        });
    }

    const disUnitsCountHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "UnitsCount", value: "" }
        });
    }

    const LoanPriceHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "LoanPrice", value: e.target.value }
        });
    }

    const AccountTypeKeyHandel = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "UsageType", value: e.target.value }
        });
    }

    const FacilitiesHandel = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Facilities", value: e.target.value }
        });
    }

    const WaterHandle = (e) => {
        console.log("water", state.Water)
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Water", value: e.target.value }
        });
    }

    const disWaterHandle = (e) => {
        console.log("water", state.Water)
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Water", value: "" }
        });
    }

    const ElectricityHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Electricity", value: e.target.value }
        });
    }

    const disElectricityHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Electricity", value: "" }
        });
    }

    const GasHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Gas", value: e.target.value }
        });
    }

    const disGasHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Gas", value: "" }
        });
    }

    const PropertyAgeYearHandle = (e) => {
        const finalDate = nowDate - e.target.value
        console.log(finalDate)
        setYearSlected(e.target.value)

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PropertyAgeYear", value: finalDate }
        });

        handleCloseYearCreatedModal()
    }

    const disPropertyAgeYearHandle = (e) => {
        setYearSlected("")
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PropertyAgeYear", value: "" }
        });
    }

    const EstateStatusHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "EstateStatus", value: e.target.value }
        });
    }

    const disEstateStatusHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "EstateStatus", value: "" }
        });
    }

    const AggregationHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Aggregation", value: e.target.value }
        });
    }

    const disAggregationHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Aggregation", value: "" }
        });
    }

    const CertificateTypeHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "CertificateType", value: e.target.value }
        });
        handleCloseSanadModal()
    }

    const disCertificateTypeHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "CertificateType", value: "" }
        });
    }

    const DirectionHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Direction", value: e.target.value }
        });
        handleCloseJahatModal()
    }

    const disDirectionHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Direction", value: "" }
        });
    }

    const FrontageHandle = (e) => {
        console.log(e.target.value)
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Frontage", value: e.target.value }
        });
        handleCloseNamaModal()
    }

    const disFrontageHandle = (e) => {
        console.log(e.target.value)
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Frontage", value: "" }
        });
    }

    const FloorHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Floor", value: e.target.value }
        });
        handleCloseKafpooshModal()
    }

    const disFloorHandle = (e) => {

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Floor", value: "" }
        });
    }

    const CoolingHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Cooling", value: e.target.value }
        });
    }

    const HeatingHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Heating", value: e.target.value }
        });
    }

    const KitchenServiceHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "KitchenService", value: e.target.value }
        });
        handleCloseKitchenModal()
    }

    const disKitchenServiceHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "KitchenService", value: "" }
        });
    }

    const PublicDescriptionHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PublicDescription", value: e.target.value }
        });
    }

    const DescriptionHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Description", value: e.target.value }
        });
    }

    const featureHandle = (e) => {
        console.log(e.target.checked)
        let value = "0"
        if (e.target.checked)
            value = "1"
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: e.target.value, value: value }
        });
    }

    const LatLongHandle = (latlng) => {
        console.log(latlng)
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Latitude", value: latlng.lat }
        });
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Longitude", value: latlng.lng }
        });
    }

    const handleChangeBaseOnPrice = (event) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "SalePriceCalcMode", value: event.target.value }
        });

    };

    const CurrentResidentPhoneNumberHandle = (event) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "CurrentResidentPhoneNumber", value: event.target.value }
        });
    };

    const meterPriceHandle = (e) => {
        if (isPriceChanging != 2)
            return

        if (state.Space != "") {
            if (state.SalePriceCalcMode == "2") {
                if (e.target.value != "") {
                    console.log("meterPriceHandle", parseFloat(state.Space) * parseFloat(e.target.value))
                    dispatch({
                        type: "UPDATE_STATE",
                        payload: { name: "SalePrice", value: (parseFloat(state.Space) * parseFloat(e.target.value)).toString() }
                    });
                }
                else {
                    dispatch({
                        type: "UPDATE_STATE",
                        payload: { name: "SalePrice", value: "" }
                    });
                }
            }
        }
        if (state.Infrastructure != "") {
            if (state.SalePriceCalcMode == "1") {
                if (e.target.value != "") {
                    dispatch({
                        type: "UPDATE_STATE",
                        payload: { name: "SalePrice", value: (parseFloat(state.Infrastructure) * parseFloat(e.target.value)).toString() }
                    });
                }
                else {
                    dispatch({
                        type: "UPDATE_STATE",
                        payload: { name: "SalePrice", value: "" }
                    });

                }
            }
        }
        setMeterPrice(e.target.value)
    }

    const SalePriceHandle = (e) => {
        if (isPriceChanging != 1)
            return

        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "SalePrice", value: e.target.value }
        });
        console.log(e.target.value)
        if (e.target.value == "") {
            setMeterPrice("")
        }
        else {
            if (state.Space != "") {
                if (state.SalePriceCalcMode == "2") {
                    console.log("meterPriceHandle", parseFloat(e.target.value) / parseFloat(state.Space))
                    setMeterPrice(parseFloat(e.target.value) / (parseFloat(state.Space)).toString())
                }
            }
            if (state.Infrastructure != "") {
                if (state.SalePriceCalcMode == "1") {
                    if (e.target.value != "") {
                        setMeterPrice(parseFloat(e.target.value) / (parseFloat(state.Infrastructure)).toString())
                    }
                    else {
                        setMeterPrice("")
                    }
                }
            }
        }

    }

    const RowHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Row", value: e.target.value }
        });
    }

    const FullNameHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "FullName", value: e.target.value }
        });
    }

    const PropertyAreaHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PropertyArea", value: e.target.value }
        });
        handleClose()
    }

    const disPropertyAreaHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PropertyArea", value: "" }
        });
    }

    const MortgagePrice1Handle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "MortgagePrice1", value: e.target.value }
        });
        setShowMortgagePrice(wordifyfa(state.MortgagePrice1))
    }

    const RentPrice1Handle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "RentPrice1", value: e.target.value }
        });
    }

    const PreSalePriceHandle = (e) => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "PreSalePrice", value: e.target.value }
        });
    }

    const areasSearchHandle = async (e) => {

        handleToggleBackdrop()
        if (e.target.value != "") {
            if (typeZone == "1")
                getAreas(true, e.target.value, "/areas/list")
            if (typeZone == "2")
                getAreas(true, e.target.value, "/webapp/divar_areas/list")
        } else {
            if (typeZone == "1")
                getAreas(true, "", "/areas/list")
            if (typeZone == "2")
                getAreas(true, "", "/webapp/divar_areas/list")
        }
    }

    useEffect(() => {
        console.log("typeZone", typeZone)
        if (typeZone == "1")
            getAreas(true, "", "/areas/list")
        if (typeZone == "2")
            getAreas(true, "", "/webapp/divar_areas/list")


    }, [typeZone])

    const propCodeHandle = async () => {
        handleToggleBackdrop()
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "properties/get/list/by/filter",
                method: "POST",
                data: {
                    "LocationId": locationId,
                    "AgencyId": userInfo.Id,
                    "Row": searchPropCode,
                    AgencyInfo: true,
                }
            }).then((res) => {

                console.log(res);
                if (res.data.result.Properties.length) {
                    for (const key in state) {
                        if (key != 'Row') {
                            if (key == "RegisterDate" || key == "ExpireDate") {


                                if (res.data.result.Properties[0][key] && res.data.result.Properties[0][key] != "")
                                    state[key] = res.data.result.Properties[0][key] * 1000

                            } else {
                                if (key == "PropertyAge") {
                                    setYearSlected(state[key])
                                }
                                state[key] = res.data.result.Properties[0][key]
                            }

                        }
                    }
                    if (state.Pictures.length) {
                        const tmp = []
                        state.Pictures.map(item => {
                            tmp.push(
                                { path: item, preview: `https://ws.iranamlaak.net/upload/property/${JSON.parse(Cookies.get('agency')).Id}/${res.data.result.Properties[0].Id}/${item}`, name: item }
                            )
                        })
                        tmp.push({})
                        setImgUploadsCount(tmp)
                        console.log("ImgUploadsCount", imgUploadsCount)

                    }
                    handleCodeMelkClose()
                } else {
                    const variant = 'error'
                    enqueueSnackbar('موردی یافت نشد!', { variant });
                    console.log("res");
                }


                handleCloseBackdrop()


            });
        } catch (e) {
            console.error(e);
            handleCloseBackdrop()
        }

        console.log("type", type)

    }

    const saveProperty = async () => {
        const addPrem = checkPropertyCount()
        // if (addPrem) {
        if (uploadingPictures) {
            const variant = 'error'
            enqueueSnackbar("در حال بارگذاری تصاویر لطفا صبر کنید...", { variant });
            return
        }
        console.log(state)
        setValidation({})
        const tmpState = { ...state }

        if (tmpState.ExpireDate && parseInt(tmpState.RegisterDate) > parseInt(tmpState.ExpireDate)) {
            const variant = 'error'
            enqueueSnackbar("تاریخ بازیابی نباید از تاریخ ثبت عقب تر باشد.", { variant });
            let tmp = { ...validation }
            tmp.ExpireDate = true
            setValidation(tmp)

            return
        }
        handleToggleBackdrop()




        if (tmpState.RegisterDate != "")
            tmpState.RegisterDate = tmpState.RegisterDate / 1000
        if (tmpState.ExpireDate != "")
            tmpState.ExpireDate = tmpState.ExpireDate / 1000

        if (!tmpState.AgencyId)
            tmpState.AgencyId = Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id

        if (!tmpState.Prefix)
            tmpState.Prefix = Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id

        if (!tmpState.LocationId)
            tmpState.LocationId = Cookies.get('locationId')

        tmpState.ImageCount = tmpState.Pictures.length

        if(type === 'exchange')
            tmpState.ForExchange = 1;

        else if(type === 'associate')
            tmpState.ForAssociate = 1;

        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/properties/new/professional",
                method: "POST",
                data: tmpState,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {

                console.log(res.data.result)
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("ملک شما با موفقیت ثبت شد.", { variant });
                    const userTmp = { ...userInfo }
                    userTmp.LastPropertyRow = +userTmp.LastPropertyRow + 1
                    setUserInfo(userTmp)

                    setTimeout(() => navigate(`/property/${res.data.result[0].PropertyId}?showMore=true`), 500);
                }
                else{
                    const variant = 'error'
                    enqueueSnackbar("خطا در ثبت ملک.", { variant });
                }

                handleCloseBackdrop()



            });
        } catch (e) {
            console.error(e);
            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
                if(e.response.data.validation){
                    setValidation(e.response.data.validation)
                }
            }
            handleCloseBackdrop()
        }
        // }
        // else {
        //     const variant = 'error'
        //     enqueueSnackbar('تعداد ملک های ثبت شده شما بیشتر از حد مجاز است.', { variant });
        // }
    }




    useEffect(() => {
        const date = new Date()
        const fullDate = `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}`
        const format = "YYYY"
        let object = { fullDate, format }
        const now = new DateObject(object).convert(persian, persian_en).format()
        setNowDate(now)
        console.log("nowDate", nowDate)
        for (let i = parseInt(now); i >= parseInt(now) - 50; i--) {

            const tmp = yearDates
            tmp.push(i)
            setYearDates(tmp)
        }

        getAreas()

        // console.log(moment().format("jYYYY/jMM/jDD"))
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "RegisterDate", value: +(new Date) }
        });

        scrollingDiv()

        document.getElementById("floorNo-container").scroll(850, 0);

    }, [])


    useEffect(() => {

        http({
            url: "/locations/city/details/" + locationId,
            method: "GET"
        }).then((res) => {

            console.log(res.data.result)
            if (res.data?.result?.City?.Latitude) {

                setPositionMap([res.data.result.City.Latitude, res.data.result.City.Longitude]);
            }
            else{
                setPositionMap([36.32386694335946, 59.579383705135136]);
            }

        }).catch((err) => console.log(err));

    }, [locationId]);


    useEffect(() => {
        setShowSalePrice(wordifyfa(state.SalePrice))
    }, [state.SalePrice])

    useEffect(() => {
        setShowPreSalePrice(wordifyfa(state.PreSalePrice))
    }, [state.PreSalePrice])

    useEffect(() => {
        dispatch({
            type: "UPDATE_STATE",
            payload: { name: "Row", value: +userInfo.LastPropertyRow + 1 }
        });
    }, [userInfo])

    const getLatLngHandle = () => {
        console.log("click")
    }

    // useEffect(() => {
    //     if (state.SalePrice == "") {
    //         if (state.Space != "") {
    //             if (BaseOnPrice == 0) {
    //                 if (meterPrice != "") {
    //                     console.log("meterPriceHandle", parseInt(state.Space) * parseInt(meterPrice))
    //                     dispatch({
    //                         type: "UPDATE_STATE",
    //                         payload: { name: "SalePrice", value: (parseInt(state.Space) * parseInt(meterPrice)).toString() }
    //                     });

    //                 }
    //                 else {
    //                     dispatch({
    //                         type: "UPDATE_STATE",
    //                         payload: { name: "SalePrice", value: "" }
    //                     });
    //                 }
    //             }
    //         }
    //         if (state.Infrastructure != "") {
    //             if (BaseOnPrice == 1) {
    //                 if (state.SalePrice != "") {
    //                     dispatch({
    //                         type: "UPDATE_STATE",
    //                         payload: { name: "SalePrice", value: (parseInt(state.Infrastructure) * parseInt(meterPrice)).toString() }
    //                     });
    //                 }
    //                 else {
    //                     dispatch({
    //                         type: "UPDATE_STATE",
    //                         payload: { name: "SalePrice", value: "" }
    //                     });
    //                 }
    //             }
    //         }
    //     }
    // }, [meterPrice])
    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(timestamp / 1000).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }

    // const dataFetchedRef = useRef(false);


    // useEffect(() => {


    //     if (state.Pictures.length) {
    //         if (dataFetchedRef.current) return;
    //         dataFetchedRef.current = true;

    //         const tmp = []
    //         state.Pictures.map(item => {
    //             tmp.push(
    //                 { path: item, preview: `https://ws.iranamlaak.net/upload/property/${JSON.parse(Cookies.get('agency')).Id}/${propInfo.Id}/${item}`, name: item }
    //             )
    //         })
    //         tmp.push({})
    //         setImgUploadsCount(tmp)
    //         console.log("ImgUploadsCount", imgUploadsCount)

    //     }


    // }, [state.Pictures])

    return (


        <PageLayout title='ثبت ملک'>

            <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, px: 2, paddingBottom: '80px' }}>
                <Grid container spacing={2}>
                    {imgUploadsCount.map((item, index) => (
                        <Grid item xs={4} key={index}>
                            <DropZone number={index + 1} setImgUploadsCount={setImgUploadsCount} imgUploadsCount={imgUploadsCount} file={item} pictures={state.Pictures} setUploadingPictures={setUploadingPictures} />

                        </Grid>
                    ))}
                </Grid>
                {/* <Box>
                        {
                            myContext ?
                            myContext.state.Pictures
                                :''
                        }
                    </Box> */}

                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, width: "100%" }}>
                    {/* <Grid container className="inputs-container">
                        <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                            <div className='flex-1 w-chile-100'>
                                
                                <InputBase value={formatJalali(state.RegisterDate)} className='flex-1' onClick={() => setShowPicker(true)} />
                                <Picker
                                    isOpen={showPicker}
                                    config={config}
                                    value={state.RegisterDate}
                                    initialValue={new Date(state.RegisterDate ? new Date(state.RegisterDate) : new Date())}
                                    minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                    maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                    onSubmit={RegisterDateHandle}
                                    onChange={RegisterDateHandle}
                                    onClose={() => setShowPicker(false)}
                                    highlightWeekends
                                />
                            </div>
                            <CalendarIcon />
                        </Grid>
                        <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                            <div className='flex-1 w-chile-100'>
                               
                                <InputBase value={formatJalali(state.ExpireDate)} className='flex-1' onClick={() => setShowExpireDatePicker(true)} />

                                <Picker
                                    isOpen={showExpireDatePicker}
                                    config={config}
                                    initialValue={new Date(state.ExpireDate ? new Date(state.ExpireDate) : new Date())}
                                    minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                    maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                    onSubmit={ExpireDateHandle}
                                    onChange={ExpireDateHandle}
                                    onClose={() => setShowExpireDatePicker(false)}
                                    highlightWeekends
                                />
                            </div>

                            <CalendarIcon />

                        </Grid>
                    </Grid> */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                        <Box className="inputs-container flex-1" sx={{ display: 'flex', alignItems: 'center' }}>
                            <div className='flex-1 w-chile-100'>

                                <InputBase value={formatJalali(state.RegisterDate)} className='flex-1' onClick={() => setShowPicker(true)} placeholder='تاریخ ثبت' />
                                <Picker
                                    isOpen={showPicker}
                                    config={config}
                                    value={state.RegisterDate}
                                    initialValue={new Date(state.RegisterDate ? new Date(state.RegisterDate) : new Date())}
                                    minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                    maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                    onSubmit={RegisterDateHandle}
                                    // onChange={RegisterDateHandle}
                                    onClose={() => setShowPicker(false)}
                                    highlightWeekends
                                />
                            </div>
                            <CalendarIcon />
                        </Box>

                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                        <Box className="inputs-container flex-1" sx={{ display: 'flex', alignItems: 'center' }}>
                            <div className='flex-1 w-chile-100'>

                                <InputBase value={formatJalali(state.ExpireDate)} className='flex-1' onClick={() => setShowExpireDatePicker(true)} placeholder='تاریخ بازیابی' />

                                <Picker
                                    isOpen={showExpireDatePicker}
                                    config={config}
                                    initialValue={new Date(state.ExpireDate ? new Date(state.ExpireDate) : new Date())}
                                    minDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 1, day: 1 })}
                                    maxDate={newDate({ year: parseInt(moment().format("jYYYY")) + 10, month: 12, day: 29 })}
                                    onSubmit={ExpireDateHandle}
                                    // onChange={ExpireDateHandle}
                                    onClose={() => setShowExpireDatePicker(false)}
                                    highlightWeekends
                                />
                            </div>
                            <CalendarIcon />
                        </Box>

                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                        <Box className="inputs-container flex-1">
                            <InputBase placeholder='کد ملک' value={state.Row} type="number" onChange={RowHandle} />
                        </Box>
                        <IconButton sx={{ backgroundColor: '#29A19C!important' }} onClick={handleClickOpenOpenCodeMelk}>
                            <CopyIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }} className="requiredInput">
                        <Box className="inputs-container flex-1">
                            <InputBase placeholder='نام مالک' value={state.FullName} onChange={FullNameHandle} />
                        </Box>
                        <IconButton sx={{ backgroundColor: '#29A19C!important' }}>
                            <ContactIcon />
                        </IconButton>
                    </Box>
                    <Box>
                        <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center" }}>
                            <InputBase placeholder='تلفن' className='flex-1' type="tel" inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} value={state.Phone} onChange={PhoneHandle} />
                            <img src='/assets/img/phone.png' alt="" className='phoneImg' />
                        </Box>
                    </Box>
                    <Box className="requiredInput">
                        <Box className={`inputs-container flex-1 ${validation.Mobile ? "error" : ''}`} sx={{ display: "flex", width: 'auto', alignItems: "center" }}>
                            <InputBase placeholder='شماره همراه' value={state.Mobile} inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} type="tel" onChange={MobileHandle} />
                            <img src='/assets/img/mobile.png' alt="" sx={{ width: "14px" }} />
                        </Box>
                    </Box>
                    {validation.Mobile ? <Typography variant='p' sx={{ color: '#d41d1d', fontSize: '12px', marginTop: '-10px' }}>شماره موبایل را بدرستی وارد کنید.</Typography> : ''}
                    <Box>
                        <Box className="inputs-container" sx={{ width: 'auto' }}>
                            <InputBase placeholder='شماره تماس ساکن فعلی' type="number" className='flex-1' value={state.CurrentResidentPhoneNumber} onChange={CurrentResidentPhoneNumberHandle} />
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 4, width: '100%' }}>
                    <Typography className='f-16 requiredInput' gutterBottom sx={{ color: '#4A4949' }}>
                        نوع ملک
                    </Typography>
                    <Box className='tab-container'>
                        <Box>
                            <Tabs value={tabValue} onChange={handleChange} className="inputs-container" sx={{ width: 'auto', p: 0, display: 'flex' }} aria-label="basic tabs example">
                                <Tab icon={<CityIcon />} sx={{ flex: 1 }} iconPosition="start" label="شهری" {...a11yProps(0)} />
                                <Tab icon={<SettingIcon />} sx={{ flex: 1 }} iconPosition="start" label="صنعتی و کشاورزی" {...a11yProps(1)} />
                            </Tabs>
                        </Box>
                        <TabPanel value={tabValue} index={0}>
                            <Grid container spacing={5} className='gap-top-20' sx={{ pt: 2 }}>
                                {data.propertyType.cities.map((city, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }} key={index}>
                                        <input type="radio" name='propertyType' value={city} checked={state.PropertyType == city} id={`item${index}`} className="d-none typeCheck" onChange={PropertyTypeHandle} />
                                        <label htmlFor={`item${index}`} className=' typeLabel w-100'>
                                            <span className="flex-1">{city}</span>

                                        </label>
                                    </Grid>
                                ))}
                                {/* {data.propertyType.map((melkItem, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="checkbox" id={`item${index}`} className="d-none typeCheck" />
                                        <label htmlFor={`item${index}`} className='typeLabel'>
                                            {melkItem}
                                        </label>
                                    </Grid>
                                ))} */}

                            </Grid>
                        </TabPanel>
                        <TabPanel value={tabValue} index={1}>
                            <Grid container spacing={5} className='gap-top-20' sx={{ pt: 2 }}>
                                {data.propertyType.industrial.map((industry, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="radio" name='propertyType' value={industry} checked={state.PropertyType == industry} id={`item${index}`} className="d-none floorCheck" onChange={PropertyTypeHandle} />
                                        <label htmlFor={`item${index}`} className='inputs-container floorLabel w-100'>
                                            <span className="flex-1">{industry}</span>
                                        </label>
                                    </Grid>
                                ))}
                            </Grid>
                        </TabPanel>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
                    <label className='f-16 text-label'>نوع کاربری</label>
                    <Grid container spacing={5} sx={{ pt: 2 }} className='gap-top-20'>
                        {data.AccountType.map((AccountTypeKey, index) => (
                            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                <input type="checkbox" id={`AccountType${index}`} value={AccountTypeKey} onChange={AccountTypeKeyHandel} className="d-none typeCheck" />
                                <label htmlFor={`AccountType${index}`} className='typeLabel'>
                                    {AccountTypeKey}
                                </label>
                            </Grid>
                        ))}

                    </Grid>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, width: '100%' }}>
                    <Typography className='f-16' gutterBottom sx={{ color: '#4A4949' }}>
                        {locationName}
                    </Typography>
                    <Box sx={{ width: '100%' }}>
                        <Box className={`inputs-container ${state.PropertyArea != "" ? 'checked' : ''}`} onClick={handleClickOpenZoneModal} sx={{ display: 'flex', width: 'auto', alignItems: 'center', cursor: 'pointer', justifyContent: 'space-between', }}>
                            {/* <InputBase onChange={PropertyAreaHandle} type="text" placeholder='محدوده' value={state.PropertyArea} />
                            <Box onClick={handleClickOpenZoneModal} sx={{
                                width: '20px !important',
                                height: '20px !important',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}> */}
                            <span>{state.PropertyArea != "" ? state.PropertyArea : "محدوده"}</span>
                            {
                                state.PropertyArea != "" ? null :
                                    <PlusIcon width="13" height="13" />}
                            {/* </Box> */}
                        </Box>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <Box className="inputs-container" sx={{ width: 'auto' }}>
                            <InputBase placeholder='آدرس' className='flex-1' value={state.PhysicalAddress} onChange={AddressHandle} />
                        </Box>
                    </Box>
                    <Box>
                        <Button className='green-btn' sx={{ borderRadius: '50px', px: 5, py: 1, fontSize: '15px' }} onClick={handleClickOpenMapModal}>
                            نقشه
                        </Button>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <label htmlFor='meter' className='f-16 text-label'>متراژ زیر بنا(متر مربع)</label>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                            <InputBase id='meter' onChange={InfrastructureHandle} type="number" value={state.Infrastructure} />
                        </Box>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <label htmlFor='meter' className='f-16 text-label'>متراژ مساحت(متر مربع)</label>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                            <InputBase id='meter' onChange={SpaceHandle} type="number" value={state.Space} />
                        </Box>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <label className='f-16 text-label'>تعداد اتاق</label>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1, overflow: "hidden" }}>
                            <Box className="numbers-scroll" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>

                                {
                                    Array.apply(0, Array(51)).map(function (x, i) {
                                        return <Box key={i}>
                                            <input type="radio" name='countRoom' id={`roomcount${i}`} value={i} checked={state.RoomsCount != "" && state.RoomsCount == i} onChange={RoomsCountHandle} onClick={disRoomsCountHandle} className="d-none NumberCheck" />
                                            <label htmlFor={`roomcount${i}`} className='NumberLabel'>
                                                {i}
                                            </label>
                                        </Box>
                                    })
                                }
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <label className='f-16 text-label'>طبقه</label>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1, overflow: "hidden" }}>
                            <Box className="numbers-scroll" id="floorNo-container" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>
                                {
                                    Array.apply(0, Array(51)).map(function (x, i) {
                                        return <Box key={i}>
                                            <input type="radio" name='floor' id={`floor${i - 25}`} value={i - 25} checked={state.StoreyNo != "" && state.StoreyNo == i - 25} onChange={StoreyNoHandle} onClick={disStoreyNoHandle} className="d-none NumberCheck" />
                                            <label htmlFor={`floor${i - 25}`} className='NumberLabel'>
                                                {i - 25 == 0 ? <span style={{ fontSize: "10px" }}>همکف</span> : i - 25}
                                            </label>
                                        </Box>
                                    })
                                }
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <label className='f-16 text-label'>تعداد طبقات
                            {/* <span className='f-10 text-muted'>مهم نیست</span> */}
                        </label>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1, overflow: "hidden" }}>
                            <Box className="numbers-scroll" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>

                                {
                                    Array.apply(0, Array(51)).map(function (x, i) {
                                        return <Box key={i}>
                                            <input type="radio" name='floorCount' id={`floorCount${i}`} value={i} checked={state.StoreyCount != "" && state.StoreyCount == i} onChange={StoreyCountHandle} onClick={disStoreyCountHandle} className="d-none NumberCheck" />
                                            <label htmlFor={`floorCount${i}`} className='NumberLabel'>
                                                {i}
                                            </label>
                                        </Box>
                                    })
                                }
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ width: "100%" }}>
                        <label className='f-16 text-label'>تعداد واحد در طبقه</label>
                        <Box className="inputs-container" sx={{ mt: 1, width: "auto", overflow: "hidden" }}>
                            <Box className="numbers-scroll" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>
                                {
                                    Array.apply(0, Array(51)).map(function (x, i) {
                                        return <Box key={i}>
                                            <input type="radio" name='countInFloor' id={`countInFloor${i}`} value={i} checked={state.UnitsCount != "" && state.UnitsCount == i} onChange={UnitsCountHandle} onClick={disUnitsCountHandle} className="d-none NumberCheck" />
                                            <label htmlFor={`countInFloor${i}`} className='NumberLabel'>
                                                {i}
                                            </label>
                                        </Box>
                                    })
                                }
                            </Box>
                        </Box>
                    </Box>
                    <Box>
                        <Box onClick={handleClickOpenFloorModal} className={`inputs-container ${state.Floors.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <Box className="overflow-three-line">
                                <Box>
                                    {state.Floors && state.Floors.length ? state.Floors.map((item, index) => {
                                        return <span key={index}>طبقه {floorTitle[item.FloorNo]} {index != state.Floors.length - 1 && "،"} </span>
                                    }) : "ثبت طبقات دیگر این ساختمان"}
                                </Box>
                            </Box>
                            {
                                state.Floors.length ? null :
                                    <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    {
                        type == 'sale' ?
                            <Box>
                                <FormControlLabel className='green-check f-16' sx={{ mr: 0 }} control={<Checkbox defaultChecked />} checked={showLoan} onChange={() => setShowLoan(!showLoan)} label="ملک دارای وام می باشد" />
                            </Box>
                            : null
                    }
                    {
                        showLoan ?
                            <Box>
                                <label htmlFor='meter' className='f-16 text-label'>میزان وام ملک</label>
                                <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                                    <InputBase id='meter' type="number" onChange={LoanPriceHandle} value={state.LoanPrice} />
                                </Box>
                            </Box>
                            :
                            null
                    }


                    <Box onClick={handleClickOpenEmkanatModal} className={`inputs-container ${state.Facilities.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                        {!state.Facilities.length ? "امکانات" :
                            <Box className="overflow-three-line">
                                <Box>
                                    {state.Facilities && state.Facilities.length ? state.Facilities.map((item, index) => {
                                        return <span key={index}>{propFacilities[item]} {index != state.Facilities.length - 1 && "،"} </span>
                                    }) : ""}
                                </Box>
                            </Box>}
                        {
                            state.Facilities.length ? null :
                                <PlusIcon width="13" height="13" />}
                    </Box>
                    <Box onClick={handleClickOpenPropertyModal} className={`inputs-container ${state.Store != "0" && state.Store != "" || state.Elec3Phase != "0" && state.Elec3Phase != "" || state.Elevator != "0" && state.Elevator != "" || state.Parking != "0" && state.Parking != "" || state.Court != "0" && state.Court != "" || state.Deadlock != "0" && state.Deadlock != "" || state.InputSeparate != "0" && state.InputSeparate != "" || state.CommercialMeter != "0" && state.CommercialMeter != "" ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                        {state.Store != "0" && state.Store != "" || state.Elec3Phase != "0" && state.Elec3Phase != "" || state.Elevator != "0" && state.Elevator != "" || state.Parking != "0" && state.Parking != "" || state.Court != "0" && state.Court != "" || state.Deadlock != "0" && state.Deadlock != "" || state.InputSeparate != "0" && state.InputSeparate != "" || state.CommercialMeter != "0" && state.CommercialMeter != "" ?
                            <Box className="overflow-three-line">
                                <Box>
                                    {state.Store != "" && state.Store != "0" && <span>{data.mainFeaturesProp.Store} ، </span>}
                                    {state.Elec3Phase != "" && state.Elec3Phase != "0" && <span>{data.mainFeaturesProp.Elec3Phase} ، </span>}
                                    {state.Elevator != "" && state.Elevator != "0" && <span>{data.mainFeaturesProp.Elevator} ، </span>}
                                    {state.Parking != "" && state.Parking != "0" && <span>{data.mainFeaturesProp.Parking} ، </span>}
                                    {state.Court != "" && state.Court != "0" && <span>{data.mainFeaturesProp.Court} ، </span>}
                                    {state.Deadlock != "" && state.Deadlock != "0" && <span>{data.mainFeaturesProp.Deadlock} ، </span>}
                                    {state.InputSeparate != "" && state.InputSeparate != "0" && <span>{data.mainFeaturesProp.InputSeparate} ، </span>}
                                    {state.CommercialMeter != "" && state.CommercialMeter != "0" && <span>{data.mainFeaturesProp.CommercialMeter} ، </span>}
                                </Box>
                            </Box> : "ویژگی های اصلی"}
                        {
                            state.Store != "0" && state.Store != "" || state.Elec3Phase != "0" && state.Elec3Phase != "" || state.Elevator != "0" && state.Elevator != "" || state.Parking != "0" && state.Parking != "" || state.Court != "0" && state.Court != "" || state.Deadlock != "0" && state.Deadlock != "" || state.InputSeparate != "0" && state.InputSeparate != "" || state.CommercialMeter != "0" && state.CommercialMeter != "" ? null :
                                <PlusIcon width="13" height="13" />}
                    </Box>
                    <Box>
                        <label className='f-16 text-label d-block mb-2'>امتیازات</label>
                        <label className='f-16'>آب</label>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiaz2Item" value="مستقل" onChange={WaterHandle} onClick={disWaterHandle} checked={state.Water == "مستقل"} className='d-none typeCheck' id='emtiaz2Item1' />
                                <label className="typeLabel w-auto text-center" htmlFor='emtiaz2Item1'>
                                    <span className='flex-1'>مستقل</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiaz2Item" value="مشترک" onChange={WaterHandle} onClick={disWaterHandle} checked={state.Water == "مشترک"} className='d-none typeCheck' id='emtiaz2Item2' />
                                <label className="typeLabel w-auto text-center" htmlFor='emtiaz2Item2'>
                                    <span className='flex-1'>مشترک</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiaz2Item" value="ندارد" onChange={WaterHandle} onClick={disWaterHandle} checked={state.Water == "ندارد"} className='d-none typeCheck' id='emtiaz2Item3' />
                                <label className="typeLabel w-auto text-center" htmlFor='emtiaz2Item3'>
                                    <span className='flex-1'>ندارد</span>
                                </label>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <label className='f-16'>برق</label>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiazBarghItem" value="مستقل" onChange={ElectricityHandle} onClick={disElectricityHandle} checked={state.Electricity == "مستقل"} className='d-none typeCheck' id='emtiazBarghItem1' />
                                <label className="typeLabel w-auto" htmlFor='emtiazBarghItem1'>
                                    <span className='flex-1'>مستقل</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiazBarghItem" value="مشترک" onChange={ElectricityHandle} onClick={disElectricityHandle} checked={state.Electricity == "مشترک"} className='d-none typeCheck' id='emtiazBarghItem2' />
                                <label className="typeLabel w-auto" htmlFor='emtiazBarghItem2'>
                                    <span className='flex-1'>مشترک</span>

                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiazBarghItem" value="ندارد" onChange={ElectricityHandle} onClick={disElectricityHandle} checked={state.Electricity == "ندارد"} className='d-none typeCheck' id='emtiazBarghItem3emtiazGaz' />
                                <label className="typeLabel w-auto" htmlFor='emtiazBarghItem3emtiazGaz'>
                                    <span className='flex-1'>ندارد</span>
                                </label>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <label className='f-16'>گاز</label>
                        <Grid container spacing={1}>

                            <Grid item xs={4}>
                                <input type='radio' name="emtiazGaz" className='d-none typeCheck' id='emtiazGaz1' value="مستقل" onChange={GasHandle} onClick={disGasHandle} checked={state.Gas == "مستقل"} />
                                <label className="typeLabel w-auto" htmlFor='emtiazGaz1'>
                                    <span className='flex-1'>مستقل</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiazGaz" className='d-none typeCheck' id='emtiazGaz2' value="مشترک" onChange={GasHandle} onClick={disGasHandle} checked={state.Gas == "مشترک"} />
                                <label className="typeLabel w-auto" htmlFor='emtiazGaz2'>
                                    <span className='flex-1'>مشترک</span>

                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="emtiazGaz" className='d-none typeCheck' id='emtiazGaz3' value="ندارد" onChange={GasHandle} onClick={disGasHandle} checked={state.Gas == "ندارد"} />
                                <label className="typeLabel w-auto" htmlFor='emtiazGaz3'>
                                    <span className='flex-1'>ندارد</span>

                                </label>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>سال ساخت</label>
                        <Box onClick={handleOpenYearCreatedModal} className={`inputs-container ${yearSlected && yearSlected != "" ? "checked" : ""} `} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <Box className="overflow-three-line">
                                <Box>
                                    {yearSlected != "" && nowDate - yearSlected != 0 ? `${yearSlected} (${nowDate - yearSlected} سال ساخت)` : yearSlected}
                                </Box>
                            </Box>
                            {yearSlected && yearSlected != "" ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>وضعیت بنا</label>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <input type='radio' name="buildStats" className='d-none typeCheck' id='buildStats1' value="نوساز" checked={state.EstateStatus == "نوساز"} onChange={EstateStatusHandle} onClick={disEstateStatusHandle} />
                                <label className="typeLabel w-auto" htmlFor='buildStats1'>
                                    <span className='flex-1'>نوساز</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="buildStats" className='d-none typeCheck' id='buildStats2' value="بازسازی شده" checked={state.EstateStatus == "بازسازی شده"} onChange={EstateStatusHandle} onClick={disEstateStatusHandle} />
                                <label className="typeLabel w-auto" htmlFor='buildStats2'>
                                    <span className='flex-1'>بازسازی شده</span>

                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="buildStats" className='d-none typeCheck' id='buildStats3' value='قدیمی' checked={state.EstateStatus == "قدیمی"} onChange={EstateStatusHandle} onClick={disEstateStatusHandle} />
                                <label className="typeLabel w-auto" htmlFor='buildStats3'>
                                    <span className='flex-1'>قدیمی</span>

                                </label>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>تراکم</label>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <input type='radio' name="tarakom" className='d-none typeCheck' id='tarakom1' onChange={AggregationHandle} value='کم' checked={state.Aggregation == "کم"} onClick={disAggregationHandle} />
                                <label className="typeLabel w-auto" htmlFor='tarakom1'>
                                    <span className='flex-1'>کم</span>
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="tarakom" className='d-none typeCheck' id='tarakom2' onChange={AggregationHandle} value='متوسط' checked={state.Aggregation == "متوسط"} onClick={disAggregationHandle} />
                                <label className="typeLabel w-auto" htmlFor='tarakom2'>
                                    <span className='flex-1'>متوسط</span>

                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <input type='radio' name="tarakom" className='d-none typeCheck' id='tarakom3' onChange={AggregationHandle} value='زیاد' checked={state.Aggregation == "زیاد"} onClick={disAggregationHandle} />
                                <label className="typeLabel w-auto" htmlFor='tarakom3'>
                                    <span className='flex-1'>زیاد</span>
                                </label>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>نوع سند</label>
                        <Box onClick={handleClickOpenSanadModal} className={`inputs-container ${state.CertificateType && state.CertificateType.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            {/* <Box className="overflow-three-line">
                                <Box>
                                    {state.CertificateType && state.CertificateType.length ? state.CertificateType.map((item, index) => {
                                        return <span key={index}>{item} {index != state.CertificateType.length - 1 && "،"} </span>
                                    }) : ""}
                                </Box>
                            </Box> */}
                            <Box className="overflow-three-line">
                                <Box>
                                    {state.CertificateType}
                                </Box>
                            </Box>
                            {state.CertificateType && state.CertificateType.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>جهت ساختمان</label>

                        <Box onClick={handleClickOpenJahatModal} className={`inputs-container ${state.Direction && state.Direction.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <span> {state.Direction} </span>
                            {state.Direction && state.Direction.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>نما</label>

                        <Box onClick={handleClickOpenNamaModal} className={`inputs-container ${state.Frontage && state.Frontage.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <snap>{state.Frontage}</snap>
                            {state.Frontage && state.Frontage.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>کفپوش</label>

                        <Box onClick={handleClickOpenKafpooshModal} className={`inputs-container ${state.Floor && state.Floor.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <span>{state.Floor}</span>
                            {state.Floor && state.Floor.length ? null : <PlusIcon width="13" height="13" />}

                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>سرمایش</label>

                        <Box onClick={handleClickOpenSarmayeshModal} className={`inputs-container ${state.Cooling && state.Cooling.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <Box className="overflow-three-line">
                                <Box>
                                    {state.Cooling && state.Cooling.length ? state.Cooling.map((item, index) => {
                                        return <span key={index}>{item} {index != state.Cooling.length - 1 && "،"} </span>
                                    }) : ""}
                                </Box>
                            </Box>
                            {state.Cooling && state.Cooling.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>گرمایش</label>

                        <Box onClick={handleClickOpenGarmayeshModal} className={`inputs-container ${state.Heating && state.Heating.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <Box className="overflow-three-line">
                                <Box>
                                    {state.Heating && state.Heating.length ? state.Heating.map((item, index) => {
                                        return <span key={index}>{item} {index != state.Heating.length - 1 && "،"} </span>
                                    }) : ""}
                                </Box>
                            </Box>
                            {state.Heating && state.Heating.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>سرویس آشپزخانه</label>

                        <Box onClick={handleClickOpenKitchenhModal} className={`inputs-container ${state.KitchenService && state.KitchenService.length ? 'checked' : ''}`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                            <span> {state.KitchenService} </span>
                            {state.KitchenService && state.KitchenService.length ? null : <PlusIcon width="13" height="13" />}
                        </Box>
                    </Box>
                    {
                        type == 'sale' ?
                            <Box>
                                <label className='f-16 text-label'>قیمت متری</label>
                                <Box className="inputs-container" sx={{ width: 'auto', p: 0 }}>
                                    <Grid container>
                                        <Grid item xs={5} sx={{ borderLeft: 'solid 1px', padding: '10px' }}>
                                            <select
                                                labelid="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={state.SalePriceCalcMode ? state.SalePriceCalcMode : ''}
                                                onInput={handleChangeBaseOnPrice}
                                                className="select-control"
                                            >
                                                <option selected value="1">بر اساس زیر بنا</option>

                                                <option value="2">بر اساس مساحت</option>
                                            </select>
                                        </Grid>
                                        <Grid item xs={7} sx={{ padding: '10px' }}>
                                            {/* <InputBase sx={{ width: '100%', height: '100%' }} /> */}
                                            <TextField
                                                label=""
                                                value={meterPrice ? parseInt(meterPrice) : ""} onChange={meterPriceHandle}
                                                name="numberformat"
                                                pattern="(\d)+"
                                                id="formatted-numberformat-input"
                                                onFocus={() => setIsPriceChanging(2)}
                                                className='remove-underline dir-ltr w-100'
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom,
                                                }}
                                                variant="standard"
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>

                            </Box>
                            : null
                    }

                    {
                        type == 'sale' ?
                            <Box>
                                <label className='f-16 text-label'>قیمت فروش</label>
                                <Box className="inputs-container requiredInput" sx={{ width: 'auto' }} >
                                    {/* <InputBase sx={{ width: '100%', height: '100%' }} InputProps={{
                                   inputComponent: NumericFormatCustom,
                               }}
                                   variant="standard"
                                   id="formatted-numberformat-input"
                                   value={values.numberformat}
                                   onChange={handlePriceChange} /> */}
                                    <TextField
                                        label=""
                                        value={state.SalePrice ? parseInt(state.SalePrice) : ''}
                                        onChange={SalePriceHandle}
                                        onFocus={() => setIsPriceChanging(1)}
                                        name="numberformat"
                                        pattern="(\d)+"
                                        id="formatted-numberformat-input"
                                        className='remove-underline dir-ltr'
                                        InputProps={{
                                            inputComponent: NumericFormatCustom,
                                        }}
                                        variant="standard"
                                    />
                                </Box>
                                <Box className='f-13' sx={{ color: '#29A19C' }}>{showSalePrice} {showSalePrice != "" ? "تومان" : ""}</Box>
                            </Box>
                            : null
                    }

                    {
                        type == 'presale' ?
                            <Box>
                                <label className='f-16 text-label'>مبلغ کل پیش فروش</label>
                                <Box className="inputs-container requiredInput" sx={{ width: 'auto' }} >
                                    <TextField
                                        label=""
                                        value={state.PreSalePrice ? parseInt(state.PreSalePrice) : ''}
                                        onChange={PreSalePriceHandle}
                                        onFocus={() => setIsPriceChanging(1)}
                                        name="numberformat"
                                        pattern="(\d)+"
                                        id="formatted-numberformat-input"
                                        className='remove-underline dir-ltr'
                                        InputProps={{
                                            inputComponent: NumericFormatCustom,
                                        }}
                                        variant="standard"
                                    />
                                </Box>
                                <Box className='f-13' sx={{ color: '#29A19C' }}>{showPreSalePrice} {showPreSalePrice != "" ? "تومان" : ""}</Box>
                            </Box>
                            : null
                    }

                    {
                        type == 'rent' ?
                            <Box>
                                <label className='f-16 text-label'>قیمت رهن</label>
                                <Box className="inputs-container" sx={{ width: 'auto' }}>
                                    {/* <InputBase sx={{ width: '100%', height: '100%' }} InputProps={{
                                inputComponent: NumericFormatCustom,
                            }}
                                variant="standard"
                                id="formatted-numberformat-input"
                                value={values.numberformat}
                                onChange={handlePriceChange} /> */}
                                    <TextField
                                        label=""
                                        value={state.MortgagePrice1 ? state.MortgagePrice1 : ''}
                                        onChange={MortgagePrice1Handle}
                                        name="numberformat"
                                        id="formatted-numberformat-input"
                                        className='remove-underline dir-ltr'
                                        InputProps={{
                                            inputComponent: NumericFormatCustom,
                                        }}
                                        variant="standard"
                                    />
                                </Box>
                                <Box className='f-13' sx={{ color: '#29A19C' }}>{showMortgagePrice} {showMortgagePrice != "" ? "تومان" : ""}</Box>
                            </Box> : null}

                    {
                        type == "rent" ?
                            <Box>
                                <label className='f-16 text-label'>قیمت اجاره</label>
                                <Box className="inputs-container requiredInput" sx={{ width: 'auto' }}>
                                    {/* <InputBase sx={{ width: '100%', height: '100%' }} InputProps={{
                                inputComponent: NumericFormatCustom,
                            }}
                                variant="standard"
                                id="formatted-numberformat-input"
                                value={values.numberformat}
                                onChange={handlePriceChange} /> */}
                                    <TextField
                                        label=""
                                        pattern="(\d)+"
                                        value={state.RentPrice1}
                                        onChange={RentPrice1Handle}
                                        name="numberformat"
                                        id="formatted-numberformat-input"
                                        className='remove-underline dir-ltr'
                                        InputProps={{
                                            inputComponent: NumericFormatCustom,
                                        }}
                                        variant="standard"
                                    />
                                </Box>
                            </Box> : null}

                    <Box>
                        <label className='f-16 text-label'>توضیحات عمومی</label>
                        <Box className='inputs-container' sx={{ width: 'auto' }}>
                            <TextareaAutosize
                                aria-label="minimum height"
                                minRows={3}
                                onChange={PublicDescriptionHandle}
                                value={state.PublicDescription}
                                style={{ width: '100%', border: '0px' }}
                            />
                        </Box>
                    </Box>
                    <Box>
                        <label className='f-16 text-label'>توضیحات خصوصی</label>
                        <Box className='inputs-container' sx={{ width: 'auto' }}>
                            <TextareaAutosize
                                aria-label="minimum height"
                                minRows={3}
                                onChange={DescriptionHandle}
                                value={state.Description}
                                style={{ width: '100%', border: '0px' }}
                            />
                        </Box>
                    </Box>
                </Box>
                {
                    state.PropertyType && state.Mobile && state.Mobile != '' && state.FullName && state.FullName != '' && (
                        (type == 'sale' && state.SalePrice && state.SalePrice != "") ||
                        (type == 'presale' && state.PreSalePrice && state.PreSalePrice != "") ||
                        (type == 'rent' && state.RentPrice1 && state.RentPrice1 != "") ||
                        type == 'exchange' || type == 'associate'
                    )
                        ?
                        <Button className='green-btn' onClick={saveProperty} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px', padding: '10px', zIndex: '11' }}>ذخیره اطلاعات</Button>
                        :
                        <Button className='gray-btn f-17' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px', padding: '10px', zIndex: '11', display: 'flex', gap: '5px' }}>گزینه های ستاره دار <StarIcon width="10" height="10" /> پر شود</Button>
                }


                {openFloorModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openFloorModal}
                    onClose={handleFloorClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                ثبت طبقات
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleFloorClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>

                        <Box>
                            <Box onClick={handleOpenFloorNumModal} className={`inputs-container`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                {floorItem.FloorNo == "" ? "طبقه را انتخاب کنید" : `طبقه ${floorItem.FloorNo}`}
                                <ArrowRightIcon className='rotate-90' />
                            </Box>

                            {/* <select
                                labelid="demo-simple-select-label"
                                id="demo-simple-select"
                                value={floorItem.FloorNo}
                                onChange={(e) => handleChangeFloor(e, "FloorNo")}
                                className="select-control"
                            >
                                <option selected>طبقه را انتخاب کنید</option>
                                <option value='0'>همکف</option>
                                <option value='1'>اول</option>
                                <option value='2'>دوم</option>
                                <option value='3'>سوم</option>
                                <option value='4'>چهارم</option>
                            </select> */}
                        </Box>
                        {
                            state.Floors.length ?
                                <Grid container spacing={1} sx={{ mt: 1 }}>
                                    {

                                        state.Floors.map(floor => {
                                            return <Grid item xs={4} sx={{ position: 'relative' }}>
                                                <Button className="inputs-container floorLabel w-100" sx={{ paddingLeft: '30px' }} onClick={() => setFloor(floor.FloorNo)}>
                                                    <span className='flex-1'>{floorTitle[floor.FloorNo]}</span>
                                                </Button>
                                                <IconButton className='delBtn' onClick={() => removeFloor(floor.FloorNo)}><CloseIcon width='15' height='15' /></IconButton>
                                            </Grid>
                                        })

                                    }
                                </Grid>
                                : null
                        }

                        <Box>
                            <label htmlFor='zirbana' className='f-16 text-label'>متراژ زیربنا(متر مربع)</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                                <InputBase id='zirbana' value={floorItem.Infrastructure} type="number" onChange={e => handleChangeFloor(e, "Infrastructure")} />
                            </Box>
                        </Box>
                        <Box sx={{ width: "100%" }}>
                            <label className='f-16 text-label'>تعداد خواب</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, overflow: "hidden" }}>
                                <Box className="numbers-scroll" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>

                                    {
                                        Array.apply(0, Array(51)).map(function (x, i) {
                                            return <Box key={i}>
                                                <input type="radio" name='floorRooms' id={`floorRooms${i}`} value={i} checked={floorItem.RoomsCount != "" && floorItem.RoomsCount == i} onChange={e => handleChangeFloor(e, 'RoomsCount')} onClick={disRoomCount} className="d-none NumberCheck" />
                                                <label htmlFor={`floorRooms${i}`} className='NumberLabel'>
                                                    {i}
                                                </label>
                                            </Box>
                                        })
                                    }
                                </Box>
                            </Box>
                        </Box>

                        <Box>
                            <label className='f-16 text-label'>آب</label>
                            <Grid container spacing={1}>

                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazItem" className='d-none typeCheck' id='floorwater1' value="مستقل" checked={floorItem.Water == "مستقل"} onChange={e => handleChangeFloor(e, 'Water')} onClick={disFloorWater} />
                                    <label className="typeLabel w-auto" htmlFor='floorwater1'>
                                        <span className='flex-1'>مستقل</span>
                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazItem" className='d-none typeCheck' id='floorWater2' value="مشترک" checked={floorItem.Water == "مشترک"} onChange={e => handleChangeFloor(e, 'Water')} onClick={disFloorWater} />
                                    <label className="typeLabel w-auto" htmlFor='floorWater2'>
                                        <span className='flex-1'>مشترک</span>

                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazItem" className='d-none typeCheck' id='floorWater3' value="ندارد" checked={floorItem.Water == "ندارد"} onChange={e => handleChangeFloor(e, 'Water')} onClick={disFloorWater} />
                                    <label className="typeLabel w-auto" htmlFor='floorWater3'>
                                        <span className='flex-1'>ندارد</span>

                                    </label>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box>
                            <label className='f-16 text-label'>برق</label>
                            <Grid container spacing={1}>
                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazBarghItem" value="مستقل" checked={floorItem.Electricity == "مستقل"} onChange={e => handleChangeFloor(e, 'Electricity')} onClick={disFloorElec} className='d-none typeCheck' id='floorElec1' />
                                    <label className="typeLabel w-auto" htmlFor='floorElec1'>
                                        <span className='flex-1'>مستقل</span>
                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazBarghItem" value="مشترک" checked={floorItem.Electricity == "مشترک"} onChange={e => handleChangeFloor(e, 'Electricity')} onClick={disFloorElec} className='d-none typeCheck' id='floorElec2' />
                                    <label className="typeLabel w-auto" htmlFor='floorElec2'>
                                        <span className='flex-1'>مشترک</span>

                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazBarghItem" value="ندارد" checked={floorItem.Electricity == "ندارد"} onChange={e => handleChangeFloor(e, 'Electricity')} onClick={disFloorElec} className='d-none typeCheck' id='floorElec3' />
                                    <label className="typeLabel w-auto" htmlFor='floorElec3'>
                                        <span className='flex-1'>ندارد</span>
                                    </label>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box>
                            <label className='f-16 text-label'>گاز</label>
                            <Grid container spacing={1}>

                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazGaz" className='d-none typeCheck' id='floorGas1' value="مستقل" checked={floorItem.Gas == "مستقل"} onChange={e => handleChangeFloor(e, 'Gas')} onClick={disFloorGas} />
                                    <label className="typeLabel w-auto" htmlFor='floorGas1'>
                                        <span className='flex-1'>مستقل</span>
                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazGaz" className='d-none typeCheck' id='floorGas2' value="مشترک" checked={floorItem.Gas == "مشترک"} onChange={e => handleChangeFloor(e, 'Gas')} onClick={disFloorGas} />
                                    <label className="typeLabel w-auto" htmlFor='floorGas2'>
                                        <span className='flex-1'>مشترک</span>

                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazGaz" className='d-none typeCheck' id='floorGas3' value="ندارد" checked={floorItem.Gas == "ندارد"} onChange={e => handleChangeFloor(e, 'Gas')} onClick={disFloorGas} />
                                    <label className="typeLabel w-auto" htmlFor='floorGas3'>
                                        <span className='flex-1'>ندارد</span>

                                    </label>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box>
                            <label htmlFor='floorPhone' className='f-16 text-label'>تلفن</label>
                            <Grid container spacing={1}>

                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazPhone" className='d-none typeCheck' id='floorPhone1' value="مستقل" checked={floorItem.Phone == "مستقل"} onChange={e => handleChangeFloor(e, 'Phone')} onClick={disFloorPhone} />
                                    <label className="typeLabel w-auto" htmlFor='floorPhone1'>
                                        <span className='flex-1'>مستقل</span>
                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazPhone" className='d-none typeCheck' id='floorPhone2' value="مشترک" checked={floorItem.Phone == "مشترک"} onChange={e => handleChangeFloor(e, 'Phone')} onClick={disFloorPhone} />
                                    <label className="typeLabel w-auto" htmlFor='floorPhone2'>
                                        <span className='flex-1'>مشترک</span>

                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type='radio' name="emtiazPhone" className='d-none typeCheck' id='floorPhone3' value="ندارد" checked={floorItem.Phone == "ندارد"} onChange={e => handleChangeFloor(e, 'Phone')} onClick={disFloorPhone} />
                                    <label className="typeLabel w-auto" htmlFor='floorPhone3'>
                                        <span className='flex-1'>ندارد</span>

                                    </label>
                                </Grid>
                            </Grid>

                        </Box>
                        <Box>
                            <label className='f-16 text-label'>توضیحات</label>
                            <Box className='inputs-container' sx={{ width: 'auto' }}>
                                <TextareaAutosize
                                    aria-label="minimum height"
                                    minRows={3}
                                    onChange={e => handleChangeFloor(e, "Description")}
                                    value={floorItem.Description}
                                    style={{ width: '100%', border: '0px' }}
                                />
                            </Box>
                        </Box>
                        <Button className="inputs-container w-100" onClick={submitFloorsHandle} sx={{ width: 'auto', mt: 1, display: 'flex', direction: 'ltr', justifyContent: 'space-between', alignItems: 'center' }}>
                            <ArrowRightIcon className='rotate-180-minus' />
                            ثبت طبقه و رفتن به طبقه بعدی
                        </Button>
                    </Box>
                    <Button className='green-btn'
                        onClick={handleFloorClose}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>ثبت همه طبقات</Button>
                </Dialog>}
                {openEmkanatModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openEmkanatModal}
                    onClose={handleEmkanatClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                امکانات
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleEmkanatClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <Grid container spacing={3} sx={{ pt: 2 }} className='gap-top-20'>
                                {Object.keys(propFacilities).map((facilitiesKey, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="checkbox" id={`facilities${index}`} className="d-none typeCheck" value={facilitiesKey} onChange={FacilitiesHandel} checked={state.Facilities.includes(facilitiesKey)} />
                                        <label htmlFor={`facilities${index}`} className='typeLabel'>
                                            {propFacilities[facilitiesKey]}
                                        </label>
                                    </Grid>
                                ))}

                            </Grid>

                        </Box>
                    </Box>
                    <Button className='green-btn'
                        onClick={handleEmkanatClose}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}

                {openProperty && <Dialog className="dialog-box"
                    fullScreen
                    open={openProperty}
                    onClose={handleProperyClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                ویژگی های اصلی
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleProperyClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>

                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', overflowX: 'hidden', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>

                        <Grid container spacing={4} sx={{ pt: 2 }} className='gap-top-20'>
                            {Object.keys(data.mainFeatures).map((feature, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                    <input type="checkbox" id={`feature${index}`} className="d-none typeCheck" value={feature} checked={state[feature] == "1"} onChange={featureHandle} />
                                    <label htmlFor={`feature${index}`} className='typeLabel'>
                                        {data.mainFeatures[feature]}
                                    </label>
                                </Grid>
                            ))}
                        </Grid>

                    </Box>

                    <Button className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}
                        onClick={handleProperyClose}
                    >انتخاب</Button>
                </Dialog>}
                {openCodeMelk && <Dialog className="dialog-box"
                    fullScreen
                    open={openCodeMelk}
                    onClose={handleCodeMelkClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {/* انتخاب محدوده */}
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCodeMelkClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                        <Typography className='f-20' sx={{ textAlign: 'center' }}>
                            در این قسمت می توانید مشخصات  ملکی که
                            می خواهید ثبت کنید را شبیه یک کد ملک
                            دیگر به ثبت برسانید
                        </Typography>
                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', direction: 'ltr', justifyContent: 'space-between', alignItems: 'center', borderColor: '#29A19C', color: '#29A19C!important' }}>
                            <ArrowRightIconGreen />
                            کد ملک قبلی
                        </Box>
                        <Box>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 3 }}>
                                <InputBase id='meter' placeholder='کد ملک مورد نظر خود را تایپ کنید' value={searchPropCode} onChange={(e) => setSearchPropCode(e.target.value)} />
                            </Box>
                        </Box>
                    </Box>
                    <Button className='green-btn' onClick={propCodeHandle} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}
                {openZoneModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openZoneModal}
                    onClose={handleClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>
                            <IconButton autoFocus color="inherit" onClick={handleClickTypeZone}>
                                <SettingIcon />
                            </IconButton>
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب محدوده
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 120px)!important", overflow: 'auto' }} id="areas-container">
                        <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center", border: '0px', bgcolor: '#EEEBEB' }}>
                            <InputBase placeholder='محدوده یا محله مورد نظر خود را وارد کنید' className='flex-1' onChange={areasSearchHandle} />
                            <IconButton>
                                <SreachIcon />
                            </IconButton>
                        </Box>

                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>


                            {
                                areasItems && areasItems.length > 0 ?
                                    areasItems.map((item, index) => (
                                        <Box sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                            <input type="radio" name='propertyType' value={item.Name} data_locationid={item.LocationId} id={`PropertyArea${index}`} className="d-none typeCheck" checked={state.PropertyArea != "" && state.PropertyArea == item.Name} onChange={PropertyAreaHandle} onClick={disPropertyAreaHandle} />
                                            <label htmlFor={`PropertyArea${index}`} className='typeLabel w-100 check-has-arrow'>
                                                <span className="flex-1">{item.Name}</span>
                                            </label>
                                        </Box>
                                    ))
                                    : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                            }
                            {
                                areasLoading ? <Box sx={{ textAlign: 'center', width: "100%", p: 2 }}>درحال بارگیری...</Box> : ""

                            }

                        </Box>
                    </Box>
                    {/* <Button
                        onClick={handleClose}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
                </Dialog>}
                {openSanadModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openSanadModal}
                    onClose={handleCloseSanadModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseSanadModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                        <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center" }}>
                            <InputBase placeholder='' className='flex-1' />
                            <IconButton>
                                <SreachIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                            <Grid container spacing={4}>
                                {data.typeDoc.map((doc, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="radio" name='sanad' id={`sanad${index}`} className="d-none typeCheck" checked={state.CertificateType && state.CertificateType == doc} value={doc} onChange={CertificateTypeHandle} onClick={disCertificateTypeHandle} />
                                        <label htmlFor={`sanad${index}`} className='typeLabel w-100 text-center check-has-arrow'>
                                            <span className="flex-1">{doc}</span>
                                        </label>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box>
                    {/* <Button
                        onClick={handleCloseSanadModal}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
                </Dialog>}
                {openJahatModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openJahatModal}
                    onClose={handleCloseJahatModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseJahatModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>

                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                            <Grid container spacing={3}>
                                {data.direction.map((jahatItem, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="radio" name='jahat' value={jahatItem} checked={state.Direction != "" && state.Direction == jahatItem} id={`direction${index}`} className="d-none typeCheck" onChange={DirectionHandle} onClick={disDirectionHandle} />
                                        <label htmlFor={`direction${index}`} className='typeLabel w-100 check-has-arrow'>
                                            <span className="flex-1">{jahatItem}</span>
                                        </label>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box>

                    {/* <Button
                        onClick={handleCloseJahatModal}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
                </Dialog>}
                {openNamaModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openNamaModal}
                    onClose={handleCloseNamaModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseNamaModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                            <Grid container spacing={3}>
                                {data.facade.map((facade, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="radio" name='nama' id={`facade${index}`} className="d-none typeCheck" value={facade} checked={state.Frontage != "" && state.Frontage == facade} onChange={FrontageHandle} onClick={disFrontageHandle} />
                                        <label htmlFor={`facade${index}`} className='typeLabel w-100 check-has-arrow'>
                                            <span className="flex-1">{facade}</span>
                                        </label>
                                    </Grid>
                                ))}

                            </Grid>

                        </Box>
                    </Box>
                    {/* <Button
                        onClick={handleCloseNamaModal}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
                </Dialog>}
                {openKafpooshModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openKafpooshModal}
                    onClose={handleCloseKafpooshModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseKafpooshModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <Grid container spacing={3}>
                                {data.flooring.map((flooring, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="checkbox" id={`kafpoosh${index}`} className="d-none typeCheck" value={flooring} checked={state.Floor != "" && state.Floor == flooring} onChange={FloorHandle} onClick={disFloorHandle} />
                                        <label htmlFor={`kafpoosh${index}`} className='typeLabel w-100 check-has-arrow'>
                                            <div>{flooring}</div>
                                        </label>
                                    </Grid>
                                ))}

                            </Grid>

                        </Box>
                    </Box>
                    {/* <Button className='green-btn'
                        onClick={handleCloseKafpooshModal}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
                </Dialog>}
                {openGarmayeshModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openGarmayeshModal}
                    onClose={handleCloseGarmayeshModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                گرمایش
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseGarmayeshModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                            <Grid container spacing={3}>
                                {data.heating.map((hitItem, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="checkbox" id={`garmaesh${index}`} className="d-none typeCheck" value={hitItem} checked={state.Heating.includes(hitItem)} onChange={HeatingHandle} />
                                        <label htmlFor={`garmaesh${index}`} className='typeLabel'>
                                            {hitItem}
                                        </label>
                                    </Grid>
                                ))}

                            </Grid>

                        </Box>
                    </Box>
                    <Button className='green-btn'
                        onClick={handleCloseGarmayeshModal}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}
                {openSarmayeshModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openSarmayeshModal}
                    onClose={handleCloseSarmayeshModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                سرمایش
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseSarmayeshModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                            <Grid container spacing={3}>
                                {data.cooling.map((coolItem, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="checkbox" id={`cooling${index}`} className="d-none typeCheck" value={coolItem} checked={state.Cooling.includes(coolItem)} onChange={CoolingHandle} />
                                        <label htmlFor={`cooling${index}`} className='typeLabel'>
                                            {coolItem}
                                        </label>
                                    </Grid>
                                ))}

                            </Grid>

                        </Box>
                    </Box>
                    <Button className='green-btn'
                        onClick={handleCloseSarmayeshModal}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}
                {openKitchenModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openKitchenModal}
                    onClose={handleCloseKitchenModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseKitchenModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                        <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <Grid container spacing={4}>
                                {data.kitchen.map((kitchen, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="radio" id={`kitchen${index}`} className="d-none typeCheck" value={kitchen} checked={state.KitchenService == kitchen} name="kitchen" onChange={KitchenServiceHandle} onClick={disKitchenServiceHandle} />
                                        <label htmlFor={`kitchen${index}`} className='typeLabel w-100 check-has-arrow'>
                                            <div>{kitchen}</div>
                                        </label>
                                    </Grid>
                                ))}

                            </Grid>

                        </Box>
                    </Box>
                    {/* <Button className='green-btn'
                        onClick={handleCloseKitchenModal}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
                </Dialog>}
                {openMapModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openMapModal}
                    onClose={handleCloseMapModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseMapModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', paddingBottom: '50px', height: '100%' }}>

                        <MapContainer center={positionMap} zoom={13} scrollWheelZoom={false} className="h-100" onClick={getLatLngHandle}>
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <LocationMarker LatLongHandle={LatLongHandle} />

                        </MapContainer>
                    </Box>

                    <Button className='green-btn'
                        onClick={handleCloseMapModal}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}
                {floorNumModal && <Dialog className="dialog-box"
                    fullScreen
                    open={floorNumModal}
                    onClose={handleCloseFloorNumModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseFloorNumModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ mt: 3, px: 2, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '5px', paddingBottom: '70px' }}>

                        {Array.apply(0, Array(23)).map(function (x, i) {
                            return <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                <input type="radio" id={`floorNum${i - 2}`} className="d-none floorCheck" value={i - 2} name="floorNum" onChange={(e) => handleChangeFloor(e, "FloorNo")} onClick={handleCloseFloorNumModal} />
                                <label htmlFor={`floorNum${i - 2}`} className='floorLabel inputs-container w-100 d-flex justify-content-around'>
                                    <div>طبقه</div>
                                    <div>{i - 2}</div>
                                </label>
                            </Box>
                        })
                        }

                    </Box>

                    <Button className='green-btn'
                        onClick={handleCloseFloorNumModal}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}

                {openTypeZone && <Dialog className="dialog-box"
                    fullScreen
                    open={openTypeZone}
                    onClose={handleOpenTypeZoneClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>
                            {/* <IconButton>
                <SettingIcon />
            </IconButton> */}
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {/* انتخاب محدوده */}
                            </Typography>

                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleOpenTypeZoneClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                    save
                </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, paddingBottom: '80px', px: 2 }}>
                        <Box>
                            <input type="radio" name='propType' id="myOptions" className="d-none typeCheck" checked={typeZone == "1"} value="موارد خودم" onChange={() => setTypeZone("1")} />
                            <label htmlFor="myOptions" className='typeLabel w-auto justify-content-right gap-10'>
                                <PersonList />
                                موارد خودم
                            </label>
                        </Box>
                        <Box>
                            <input type="radio" name='propType' id="daryafti" className="d-none typeCheck" checked={typeZone == "2"} value="موارد دریافتی از پایش" onChange={() => setTypeZone("2")} />
                            <label htmlFor="daryafti" className='typeLabel w-auto justify-content-right gap-10'>
                                <DownloadIcon />
                                موارد دریافتی از پایش
                            </label>
                        </Box>
                    </Box>
                    <Button className='green-btn' onClick={handleOpenTypeZoneClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>جستجو</Button>
                </Dialog>}

                {yearCreated && <Dialog className="dialog-box"
                    fullScreen
                    open={yearCreated}
                    onClose={handleCloseYearCreatedModal}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: '#fff', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب کنید
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleCloseYearCreatedModal}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ mt: 3, px: 2, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '5px', paddingBottom: '70px' }}>
                        {yearDates.map(function (date, i) {
                            return <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                <input type="radio" id={`year${date}`} className="d-none floorCheck" checked={yearSlected == date} value={date} name="year" onChange={PropertyAgeYearHandle} onClick={disPropertyAgeYearHandle} />
                                <label htmlFor={`year${date}`} className='floorLabel inputs-container w-100 d-flex justify-content-around'>
                                    <div>{nowDate - date != 0 ? `${date} (${nowDate - date} سال ساخت)` : date} </div>
                                </label>
                            </Box>
                        })}
                    </Box>

                    {/* <Button className='green-btn'
                        onClick={handleCloseYearCreatedModal}
                        sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
                </Dialog>}

            </Box >
        </PageLayout >

    );
}

export default PropertyReg;